import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";

const ComponentLoadingBoundary = ({
  loading = false,
  children,
  label = "Loading component",
  minHeight = 40,
  size = 24,
  delay = 120,
  overlaySx = {},
  sx = {},
}) => {
  const [showProgress, setShowProgress] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowProgress(false);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setShowProgress(true);
    }, Math.max(0, Number(delay) || 0));

    return () => window.clearTimeout(timer);
  }, [delay, loading]);

  return (
    <Box
      aria-busy={loading}
      sx={{
        position: "relative",
        minHeight: loading ? minHeight : undefined,
        minWidth: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          opacity: showProgress ? 0.55 : 1,
          pointerEvents: loading ? "none" : "auto",
          transition: "opacity 120ms ease",
        }}
      >
        {children}
      </Box>

      {showProgress && (
        <Box
          role="status"
          aria-label={label}
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "inherit",
            bgcolor: theme =>
              theme.palette.mode === "dark"
                ? "rgba(18, 18, 18, 0.42)"
                : "rgba(255, 255, 255, 0.58)",
            ...overlaySx,
          }}
        >
          <CircularProgress size={size} />
        </Box>
      )}
    </Box>
  );
};

export default ComponentLoadingBoundary;
